<script>
import Price from "$vueCommon/components/Price.vue";

export default {
    components: {Price},
    props: {
        order: Object,
        payment: Object,
        orderPaymentStatus: Boolean
    }
}
</script>
<template>
    <div class="row">
        <div class="col-lg-8 offset-lg-2">
            <div class="payment-complete text-center py-5">
                <h1>{{ $translate('checkout.thank_you_for_choosing_us_we_have_received_your_order') }}</h1>
                <p class="order-received mt-4">{{ $translate('checkout.your_order_will_be_processed_in_shortest_possible_time') }}</p>
                <div class="card mb-5">
                    <div class="order-details card-body p-4">
                        <div>
                            <strong class="text-primary">{{ $translate('checkout.order_number') }}: </strong>
                            <a
                                :href="`/manager/orders/details/${order.id}`"
                                :title="order.number"
                                class="text-decoration-none"
                            >
                                {{ order.number }}
                            </a>
                        </div>
                        <div>
                            <strong class="text-primary">{{ $translate('checkout.order_value') }}: </strong>
                            <Price :price="order.total" :old-price="order.old_total"></Price>
                        </div>
                        <div>
                            <strong class="text-primary">{{ $translate('checkout.method_of_payment') }}:</strong> {{ payment.name }}
                        </div>
                        <div v-if="payment.slug === 'BankTransfer'" class="mt-4">
                            <p class="h4 mb-4"><strong>{{ $translate('checkout.please_send_your_payment_to_our_account') }}</strong></p>
                            <p>
                                DOMENY.TV MSERWIS Sp. z o.o.<br>
                                ul. Stacyjna 1/63<br>
                                53-613 Wroclaw<br>
                                Poland
                            </p>
                            <p>
                                <template v-if="order.currency === 'USD'">
                                    IBAN: PL 47 1050 1575 1000 0090 3142 5623<br>
                                    SWIFT - INGBPLPW<br>
                                    {{ $translate('checkout.bank_name') }} - ING Bank Slaski S.A.
                                </template>
                                <template v-if="order.currency === 'EUR'">
                                    IBAN: PL 91 1050 1575 1000 0090 3142 5607<br>
                                    SWIFT - INGBPLPW<br>
                                    {{ $translate('checkout.bank_name') }} - ING Bank Slaski S.A.
                                </template>
                            </p>
                            <p class="h5"><strong>{{ $translate('checkout.please_provide_your_order_number_as_payment_title') }}</strong></p>
                            <div class="alert alert-warning mt-3 mb-3" role="alert" v-html="$translate('checkout.please_make_payment_as_soon_as_you_can_domain_names_cannot_be_reserved_and_its_availability_changes_fast', {url: '/payment-details'})"></div>
                            <div class="alert alert-warning mt-0 mb-0" role="alert" v-html="$translate('checkout.you_can_track_your_order_online_in_manager_area', {url: '/manager/orders'})"></div>
                        </div>
                        <div v-if="payment.slug === 'PrepaidBalance' && !orderPaymentStatus">
                            {{ $translate('checkout.you_dont_have_sufficient_money_in_your_prepaid_balance_top_up_your_prepaid_balance', {url: '/manager/orders/balance-payment'}) }}
                        </div>
                    </div>
                </div>
                <div class="row contact-details">
                    <div class="col-6 offset-3">
                        <div class="d-flex align-items-center justify-content-center">
                            <i class="fas fa-fw fa-envelope fa-2x text-secondary me-2"></i>
                            <p class="mb-0 ml-2">
                                <a href="mailto:info@letsdomains.com">info@letsdomains.com</a>
                            </p>
                            <noscript>{{ $translate('contact.please_enable_js_to_see_email_address') }}</noscript>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
